import { FunctionComponent } from "react";
import styles from "./underTitle.module.scss";

const UnderTitle: FunctionComponent<{
  children: string;
  className?: string;
}> = ({ children, className = "" }) => {
  const underTitleClass = className + styles.underTitle;
  return <p className={underTitleClass}>{children}</p>;
};

export default UnderTitle;
